import { useRef, useState } from 'react';
import { MoreHorizontal } from 'lucide-react';
import { Drawer, cn } from '@eombor/ui';
import { t } from '../../shared/i18n/index.js';
import { AppSettings } from '../../shared/settings/AppSettings.js';
import { DESKTOP_QUERY, useMediaQuery } from '../../shared/ui/useMediaQuery.js';
import { Menu } from './Menu.js';

/** Barmoq nishoni — 44px dan kichik bo'lmasin. */
const TRIGGER_CLASS = 'size-11 shrink-0 justify-center';

/**
 * SOZLAMALAR — header'dagi tugma ostida.
 *
 * Til va ko'rinish bu yerda turadi, pastdagi «Menyu» sheet'da emas: u
 * sheet SAHIFA BO'LIMLARI ro'yxati va sozlama uning oxirida yot narsa
 * bo'lib qolgandi.
 *
 * Ikki ko'rinish, bitta mazmun: monitorda o'ng-yuqoridan ochiladigan
 * panel, telefonda esa pastdan chiqadigan sheet — bosh barmoqqa yaqin.
 * Ikkalasida ham ichi bitta `AppSettings`, ya'ni boshqaruvlar
 * takrorlanmaydi va holat bitta store'dan o'qiladi.
 */
export const SettingsMenu = () => {
  const desktop = useMediaQuery(DESKTOP_QUERY);
  const [open, setOpen] = useState(false);
  const triggerRef = useRef<HTMLButtonElement | null>(null);

  const label = t('settings.title');

  if (desktop) {
    return (
      <Menu
        label={label}
        popupRole="group"
        triggerClassName={TRIGGER_CLASS}
        panelClassName="w-[20rem] p-4"
        trigger={<MoreHorizontal size={18} aria-hidden />}
      >
        <AppSettings />
      </Menu>
    );
  }

  return (
    <>
      <button
        ref={triggerRef}
        type="button"
        aria-label={label}
        aria-haspopup
        aria-expanded={open}
        onClick={() => setOpen(true)}
        className={cn(
          'flex items-center justify-center rounded-[var(--radius-sm)] text-text-muted',
          'transition-[background-color,color,transform] duration-[var(--motion-fast)]',
          'ease-[var(--ease-standard)] hover:bg-surface-2 hover:text-text',
          'active:scale-[0.96]',
          TRIGGER_CLASS,
        )}
      >
        <MoreHorizontal size={20} aria-hidden />
      </button>

      {/* Pastki sheet — «Menyu» bilan AYNAN bir xil komponent: fokus
          qopqoni, `Esc`, skroll qulfi va fokusni qaytarish u yerda
          allaqachon yozilgan. */}
      <Drawer
        open={open}
        onClose={() => setOpen(false)}
        title={label}
        closeLabel={t('tabbar.close')}
        className="[&>header]:px-4 [&>header]:py-4"
      >
        <div className="px-4 pb-4">
          <AppSettings />
        </div>
      </Drawer>
    </>
  );
};
